import { render, staticRenderFns } from "./AttendancePriority.vue?vue&type=template&id=d4fe427a&scoped=true"
import script from "./AttendancePriority.vue?vue&type=script&lang=js"
export * from "./AttendancePriority.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4fe427a",
  null
  
)

export default component.exports